<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          <CCol sm="12" lg="12" >       
            <div class="content-wrapper">
              <div id="app">
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' locale='zh-TW' :dataSource='datas' height='550' :queryCellInfo='onQueryCellInfo'
                  :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                    :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                    :toolbarClick="toolbarClick" :recordDoubleClick="recordDoubleClick" :editSettings='editSettings' :rowSelected="rowSelected" >                             
                    <e-columns>                
                        <e-column field='materials_id' headerText='料號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>              
                        <e-column field='materials_name' headerText='料名' width='220'></e-column>       
                        <e-column field='spec' headerText='規格' width='140'></e-column>      
                        <e-column field='warehouse' headerText='庫別' width='140'></e-column>      
                        <e-column field='unit' headerText='單位' width='80'></e-column>   
                        <e-column field='week2_use' headerText='近2周使用量' format="N2" width='160' textAlign='Right'></e-column>   
                        <e-column field='week4_use' headerText='近2~4周使用量' format="N2" width='160' textAlign='Right' ></e-column>   
                        <e-column field='none_use' headerText='預計使用量' format="N2" width='160' textAlign='Right'></e-column>   
                        <e-column field='average_use' headerText='平均每日需求量' format="N2" width='160' textAlign='Right' ></e-column>   
                        <e-column field='average_use_d' headerText='標準差' width='120' textAlign='Right' ></e-column> 
                        <e-column field='actual' headerText='實際庫存量' width='140' format="N2" textAlign='Right' ></e-column> 
                        <e-column field='service_z' headerText='服務水準' width='140' textAlign='Right' ></e-column> 
                        <e-column field='delivery_date' headerText='平均交期' width='140' textAlign='Right' ></e-column> 
                        <e-column field='safity_value' headerText='安全庫存值' width='180'  textAlign='Right'></e-column>
                        <e-column field='percentage' headerText='安全庫存' :allowFiltering='false' :allowSorting='false' width='180' :template='progessTemplate'></e-column>
                        <e-column field='user' headerText='更新人員' width='160' :isPrimaryKey='true'></e-column> 
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>             
          <ejs-dialog ref="safifyDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true'  :visible='false' :header='"修改標準差數值"' :buttons='e_safity_buttons' width='600px'>
            <div class="form-row">
              <div class="form-group col-md-12">
                <div class="alert alert-primary" role="alert">
                  <div class="form-row">
                    <div class="form-group col-md-4">服務水準</div>
                    <div class="form-group col-md-4">缺貨風險</div>
                    <div class="form-group col-md-4">Z值</div>
                  </div>
                  <hr style="margin-top: 0px;margin-bottom: 10px;">
                  <div class="form-row">
                    <div class="form-group col-md-4">90%</div>
                    <div class="form-group col-md-4">10%</div>
                    <div class="form-group col-md-4">1.28</div>
                  </div>
                  <hr style="margin-top: 0px;margin-bottom: 10px;">
                  <div class="form-row">
                    <div class="form-group col-md-4">95%</div>
                    <div class="form-group col-md-4">5%</div>
                    <div class="form-group col-md-4">1.65</div>
                  </div>
                  <hr style="margin-top: 0px;margin-bottom: 10px;">
                  <div class="form-row">
                    <div class="form-group col-md-4">97.5%</div>
                    <div class="form-group col-md-4">2.5%</div>
                    <div class="form-group col-md-4">1.96</div>
                  </div>
                  <hr style="margin-top: 0px;margin-bottom: 10px;">
                  <div class="form-row">
                    <div class="form-group col-md-4">99%</div>
                    <div class="form-group col-md-4">1%</div>
                    <div class="form-group col-md-4">2.33</div>
                  </div>
                  <hr style="margin-top: 0px;margin-bottom: 10px;">
                  <div class="form-row">
                    <div class="form-group col-md-4">99.9%</div>
                    <div class="form-group col-md-4">0.1%</div>
                    <div class="form-group col-md-4">3.08</div>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <span class="about-title-verify">料號</span>
                <ejs-textbox id="ProductNo"  floatLabelType="Always" :enabled="false" v-model="e_materials_id" ></ejs-textbox>
              </div>    
              <div class="form-group col-md-6">
                <span class="about-title-verify">料名</span>
                <ejs-textbox id="ProductName" floatLabelType="Always" :enabled="false" v-model="e_materials_name" ></ejs-textbox>
              </div>    
              <div class="form-group col-md-6">               
                <span class="about-title-verify">服務水準(滿足客戶需求、不缺貨的機率)</span>
                <ejs-dropdownlist :dataSource='serviceListData'  allowObjectBinding='true' :allowFiltering='true' v-model="e_service_z" :fields='dropDownFields'  ></ejs-dropdownlist>                    
              </div>   
              <div class="form-group col-md-6">                
                <span class="about-title">標準差(衡量數據「波動大小」)</span>       
                <ejs-numerictextbox id="numeric" format="p2" :step="0.1" :min="0" :max="1" v-model="e_average_use_d"></ejs-numerictextbox>            
              </div>     
            </div>            
          </ejs-dialog>
        </CRow>
        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
      </CCardBody>   
    </CCard>
</template>
<style lang="scss" src="../../scss/grid.scss"></style>
<script>

  import Vue from "vue";
  import Loading from 'vue-loading-overlay';
  import { L10n, enableRipple  } from '@syncfusion/ej2-base';
  import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
  import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
  import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
  import { ToastComponent, } from "@syncfusion/ej2-vue-notifications";
  import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
  import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
  import zhtwLocalization  from '../language/language.json';

  L10n.load(zhtwLocalization);
  enableRipple(true);
  Vue.use(DialogPlugin);
  Vue.use(GridPlugin);    
  Vue.use(ButtonPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(NumericTextBoxPlugin );
  Vue.use(RadioButtonPlugin);
  Vue.use(TooltipPlugin);
  Vue.use(Loading);

  let Loader      = undefined;

  export default {
  name: 'GetMaterials',
  components: {
    'ejs-toast': ToastComponent,
    // 'ejs-button': ButtonComponent,
  },
  data: function() {
    return {
      limit : localStorage.getItem('production'), 
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      datas : null,
      dropDownFields: { text: 'text', value: 'value' },
      serviceListData : [],
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      pageSettings: { pageSizes: [15, 30, 50, 100], pageCount: 4 }, 
      toolbar: [
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('32') < 0 },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   
      selectionSettings: { persistSelection: false },
      filterSettings: { type: 'CheckBox' },       
      e_safity_buttons: [
        {click: this.editPutSafityOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ], 
      e_safity_selectRow: null, e_materials_id: null, e_materials_name: null, e_service_z: null, e_average_use_d: null,
      freightrules:  { required: true, min: 0, number: true},
      progessTemplate: function () {
        return {
          template: Vue.component('progessTemplate', {
            template: `<div id="myProgress" class="pbar">
              <div id="myBar" :class="{'bar': true, 'progressdisable': data.percentage < 70}" :style="{'width': width}">
                <div id="pbarlabel" class="barlabel" v-html=width ></div>
                </div>
              </div>`,
              data: function () { return { data: {}, inactive: 'Inactive' }; },
            computed: {
              width: function () {  
                return this.data.percentage + '%';
              }
            }
          })
        }
      },         
    };
  },
  methods: {    
    onload:function() {
      // 初始化
    },
    submit:function() {
      this.$emit('onGetMaterialsClose');
    },
    
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    }, 
    recordDoubleClick: function () {  
      this.$refs.safifyDialog.show();
    },
    toolbarClick: function(args) {
      if (args.item.id == "Export") {
          this.$refs.grid.excelExport({ fileName:this.formatDate(new Date())+'庫存清單.xlsx' });
      }
      if (args.item.id == "Edit") {
        this.$refs.safifyDialog.show();
      }
    },   
    safityCheckHeader:function() {
      this.toolbar = [
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_safity_selectRow == undefined },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'];
    },
    rowSelected: function(args) { 
      this.e_safity_selectRow  = args.row.getAttribute('aria-rowindex');  
      this.e_materials_id = args.data.materials_id;
      this.e_materials_name = args.data.materials_name;
      this.e_service_z = args.data.service_z;
      this.e_average_use_d = args.data.average_use_d / 100;
      this.safityCheckHeader();         
    },    
    getData: function () {  
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Stock`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.hideLoading();    
        this.datas = response.data.datas;
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    editPutSafityOkClick: function() {
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Stock',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {            
            materials_id: this.e_materials_id,
            average_use_d: (this.e_average_use_d * 100).toString(),
            service_z: this.e_service_z.toString()
          },        
      })
      .then((response) => {     
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
        this.showMsg('修改成功!');     
        this.$refs.safifyDialog.hide();    
        this.hideLoading();
        this.getData();
      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },
    getServiceList: function () {  
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Stock/Service`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.serviceListData = response.data.datas;
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    formatDate(date) {
        let yyyy = date.getFullYear();
        let mm = String(date.getMonth() + 1).padStart(2, '0');      
        let dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'red',
        loader: 'dots',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
      Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
  },
  created() {
    this.getData();
    this.getServiceList();
  },
  mounted() {
    
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
   
  }  
}
</script>
<style lang="scss" src="../../scss/base.scss"></style>